import { SITE, IMAGES, OUTLETS } from "../data/site";
import { Stamp } from "../components/Stamp";
import { SauceDrip, IconPin, IconArrowUpRight, IconFlame } from "../components/Icons";

const MARQUEE = [
  "Blenger",
  "Saus Luber",
  "Patty Homemade",
  "Est. 2004",
  "It's Worth The Wait",
  "Barito – Blok M",
];

const SIGNATURES = [
  {
    no: "01",
    img: IMAGES.cheeseX2,
    name: "Cheese Burger X2",
    desc: "Menu paling diburu: patty sapi homemade, telur, smoked beef, dan keju leleh berlapis yang luber di tiap gigitan.",
    stamp: "Paling Diburu",
    testid: "signature-item-cheese-burger-x2",
  },
  {
    no: "02",
    img: IMAGES.cheeseBurger,
    name: "Cheese Burger",
    desc: "Klasik yang bikin nama Blenger besar: patty juicy, keju leleh, dan siraman saus mayo-BBQ yang nggak pelit.",
    stamp: "Klasik",
    testid: "signature-item-cheese-burger",
  },
  {
    no: "03",
    img: IMAGES.chilliDog,
    name: "Chilli Dog XL",
    desc: "Hot dog ukuran jumbo dengan saus chili gurih-pedas. Buat yang laparnya beneran, bukan lapar mata.",
    stamp: "Jumbo",
    testid: "signature-item-chilli-dog-xl",
  },
];

export default function Home() {
  return (
    <>
      {/* HERO — typography-dominant, layered photography */}
      <section className="relative overflow-hidden px-5 pb-16 pt-28 md:pt-36" data-testid="hero-section">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -top-4 left-1/2 -translate-x-1/2 select-none whitespace-nowrap font-display text-[24vw] leading-none text-white/[0.04]"
        >
          BLENGER
        </div>
        <div className="relative mx-auto grid max-w-6xl items-center gap-12 md:grid-cols-12">
          <div className="md:col-span-7">
            <Stamp className="-rotate-3 bg-coal text-cheddar">Est. 2004 • Barito–Blok M</Stamp>
            <h1 className="mt-6 font-display text-4xl uppercase leading-[0.95] tracking-tight text-cream sm:text-5xl lg:text-6xl">
              Burger jalanan legendaris Jaksel yang misinya satu:{" "}
              <span className="text-blood">bikin lo blenger.</span>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-sand sm:text-lg">
              Burger Blenger lahir dari lapak 2×1 meter di kawasan Barito, Blok M,
              tahun 2004. Roti dan patty dibuat sendiri, saus mayo-BBQ-nya luber
              sampai netes. Antrinya panjang?{" "}
              <em className="text-cream">It's worth the wait.</em>
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a href="/menu/" data-testid="hero-menu-button" className="btn-primary px-7 py-3.5 text-sm">
                Lihat Menu
              </a>
              <a href="/lokasi/" data-testid="hero-location-button" className="btn-ghost px-7 py-3.5 text-sm">
                Cari Outlet
              </a>
            </div>
            <ul className="mt-10 flex flex-wrap gap-x-8 gap-y-3 font-mono text-[11px] uppercase tracking-[0.18em] text-sand">
              <li className="flex items-center gap-2">
                <IconFlame className="h-4 w-4 text-ember" /> Bun &amp; Patty Homemade
              </li>
              <li className="flex items-center gap-2">
                <IconFlame className="h-4 w-4 text-ember" /> Saus Luber Khas
              </li>
              <li className="flex items-center gap-2">
                <IconFlame className="h-4 w-4 text-ember" /> Harga Lapak
              </li>
            </ul>
          </div>

          <div className="relative md:col-span-5">
            <img
              src={IMAGES.hero.src}
              alt={IMAGES.hero.alt}
              width={IMAGES.hero.w}
              height={IMAGES.hero.h}
              fetchPriority="high"
              data-testid="hero-image"
              className="aspect-[4/5] w-full rotate-2 border-4 border-cream/10 object-cover shadow-[0_30px_80px_-20px_rgba(217,35,35,0.4)]"
            />
            <Stamp className="absolute -left-4 -top-5 -rotate-6 bg-coal text-blood shadow-lg">
              Saus Luber!
            </Stamp>
            <Stamp className="absolute -bottom-4 right-3 rotate-6 bg-coal text-cheddar shadow-lg">
              Puas Maksimal
            </Stamp>
          </div>
        </div>
      </section>

      {/* MARQUEE */}
      <div className="overflow-hidden border-y-4 border-coal bg-blood py-3" aria-hidden="true">
        <div className="marquee-track flex w-max items-center gap-10 font-display text-2xl tracking-[0.15em] text-cream">
          {[...MARQUEE, ...MARQUEE, ...MARQUEE].map((t, i) => (
            <span key={i} className="flex items-center gap-10">
              {t} <span className="text-cheddar">•</span>
            </span>
          ))}
        </div>
      </div>

      {/* SIGNATURE — numbered editorial rows */}
      <section className="mx-auto max-w-6xl px-5 py-20 md:py-28" data-testid="signature-section">
        <header className="max-w-2xl">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-cheddar">Andalan Lapak</p>
          <h2 className="mt-3 font-display text-2xl uppercase tracking-tight text-cream sm:text-3xl lg:text-4xl">
            Tiga yang bikin orang rela antri.
          </h2>
        </header>
        <div className="mt-12">
          {SIGNATURES.map((s) => (
            <article
              key={s.no}
              data-testid={s.testid}
              className="grid items-center gap-8 border-t border-white/10 py-12 md:grid-cols-12"
            >
              <span aria-hidden="true" className="font-display text-7xl leading-none text-white/10 md:col-span-1">
                {s.no}
              </span>
              <div className="md:col-span-4">
                <img
                  src={s.img.src}
                  alt={s.img.alt}
                  width={s.img.w}
                  height={s.img.h}
                  loading="lazy"
                  decoding="async"
                  className="aspect-[4/3] w-full border border-white/10 object-cover transition-transform duration-300 hover:-translate-y-1.5"
                />
              </div>
              <div className="md:col-span-7">
                <Stamp className="text-blood">{s.stamp}</Stamp>
                <h3 className="mt-4 font-display text-xl uppercase tracking-wide text-cream sm:text-2xl">
                  {s.name}
                </h3>
                <p className="mt-3 max-w-lg leading-relaxed text-sand">{s.desc}</p>
                <a
                  href="/menu/"
                  data-testid={`${s.testid}-menu-link`}
                  className="mt-5 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.18em] text-cheddar transition-colors hover:text-cream"
                >
                  Lihat di menu <IconArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* KAMUS LAPAK — typographic signature band */}
      <section className="bg-cream text-coal" data-testid="kamus-section">
        <SauceDrip className="block h-10 w-full text-coal md:h-14" />
        <div className="mx-auto max-w-4xl px-5 py-20 text-center md:py-24">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-blood">Kamus Lapak</p>
          <p className="mt-6 font-display text-6xl uppercase leading-none tracking-tight sm:text-7xl lg:text-8xl">
            blen·ger
          </p>
          <p className="mt-6 font-mono text-sm uppercase tracking-[0.15em] text-coal/70">
            /bléng·ger/ — adjektiva, bahasa Jawa
          </p>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed sm:text-lg">
            Kenyang berlebih sampai puas maksimal. Itulah standar porsi di sini
            sejak hari pertama. Kalau pulang masih laper, berarti ada yang salah.
          </p>
        </div>
      </section>

      {/* STORY SPLIT */}
      <section className="mx-auto grid max-w-6xl items-center gap-12 px-5 py-20 md:grid-cols-2 md:py-28" data-testid="story-section">
        <div className="relative">
          <img
            src={IMAGES.stallBW.src}
            alt={IMAGES.stallBW.alt}
            width={IMAGES.stallBW.w}
            height={IMAGES.stallBW.h}
            loading="lazy"
            decoding="async"
            className="aspect-[10/7] w-full -rotate-1 border-4 border-cream/10 object-cover"
          />
          <Stamp className="absolute -right-3 -top-4 rotate-6 bg-coal text-cheddar">2004</Stamp>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-cheddar">Cerita Kami</p>
          <h2 className="mt-3 font-display text-2xl uppercase tracking-tight text-cream sm:text-3xl lg:text-4xl">
            Dari lapak 2×1 meter di Barito.
          </h2>
          <p className="mt-5 leading-relaxed text-sand">
            Tahun 2004, {SITE.founder} membuka lapak burger mungil di kawasan
            Barito, Blok M. Semua dibuat sendiri — roti, patty, sampai sausnya —
            dengan porsi yang nggak tanggung-tanggung. Dua puluh tahun lebih
            kemudian, lapak itu jadi jujukan burger jalanan Jakarta Selatan.
          </p>
          <a
            href="/tentang/"
            data-testid="story-read-more-link"
            className="mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.18em] text-cheddar transition-colors hover:text-cream"
          >
            Baca cerita lengkap <IconArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </section>

      {/* OUTLETS BAND */}
      <section className="border-t border-white/10 bg-coal2" data-testid="outlets-section">
        <div className="mx-auto max-w-6xl px-5 py-20 md:py-24">
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-cheddar">Mampir</p>
              <h2 className="mt-3 font-display text-2xl uppercase tracking-tight text-cream sm:text-3xl lg:text-4xl">
                Lapaknya di sekitar lo.
              </h2>
            </div>
            <a
              href="/lokasi/"
              data-testid="outlets-all-link"
              className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.18em] text-cheddar transition-colors hover:text-cream"
            >
              Semua lokasi <IconArrowUpRight className="h-4 w-4" />
            </a>
          </div>
          <ul className="mt-10 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
            {OUTLETS.map((o) => (
              <li key={o.id} className="bg-coal2 p-6 transition-colors hover:bg-neutral-800/60" data-testid={`outlet-preview-${o.id}`}>
                <IconPin className="h-5 w-5 text-blood" />
                <h3 className="mt-4 font-display text-xl uppercase tracking-wide text-cream">{o.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-sand">{o.area}</p>
                <a
                  href={o.maps}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`outlet-preview-${o.id}-directions`}
                  className="mt-4 inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.15em] text-cheddar transition-colors hover:text-cream"
                >
                  Petunjuk arah <IconArrowUpRight className="h-3.5 w-3.5" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* CTA BAND */}
      <section className="relative overflow-hidden" data-testid="cta-section">
        <img
          src={IMAGES.streetNight.src}
          alt=""
          width={IMAGES.streetNight.w}
          height={IMAGES.streetNight.h}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover opacity-20"
        />
        <div className="relative mx-auto max-w-4xl px-5 py-24 text-center md:py-32">
          <h2 className="font-display text-2xl uppercase tracking-tight text-cream sm:text-3xl lg:text-4xl">
            Laper berat? Jangan tanggung-tanggung.
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-sand sm:text-lg">
            Antri dulu, blenger kemudian. {SITE.slogan}.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <a href="/menu/" data-testid="cta-menu-button" className="btn-primary px-7 py-3.5 text-sm">
              Lihat Menu
            </a>
            <a
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-instagram-button"
              className="btn-ghost px-7 py-3.5 text-sm"
            >
              DM {SITE.instagramHandle}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
